import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { FunctionLevel } from './function-level.interface';
import { FunctionLevelService } from './function-level.service';
const service = new FunctionLevelService();

export interface FunctionLevelState {
   functionLevels: Array<FunctionLevel>;
}

const FunctionLevelStore: Module<FunctionLevelState, StoreState> = {
   namespaced: true,
   state: {
      functionLevels: [],
   },
   getters: {},
   mutations: {
      SET_FUNCTION_LEVELS(state, functionLevels: Array<FunctionLevel>) {
         state.functionLevels = functionLevels;
      },
   },
   actions: {
      async getFunctionLevels(context) {
         const functionLevels = await service.getFunctionLevels();
         context.commit('SET_FUNCTION_LEVELS', functionLevels.data);
         return functionLevels.data;
      },
   },
};

export default FunctionLevelStore;
